import { DependencyList, EffectCallback, useEffect } from 'react';
import { useOrganizationsStateContext } from 'providers/Organizations';

/**
 * useEffect wrapper that auto-fires when the active organization
 * (parent or sub) changes. Reads `orgVersion` from the orgs context
 * — a monotonic counter bumped by onChangeParent/onChangeSub via
 * resetData (P22.3) — and appends it to the dep array.
 *
 * Replaces the legacy Apollo `client.refetchQueries(...)` cache
 * invalidation on org switch. Use this for list-page / dashboard
 * fetches whose data set is org-scoped (the instance interceptor
 * sends the active `organization` header on every REST call).
 *
 * Do NOT use for effects that should be insulated from org switches
 * (modal-open hooks, detail-by-URL-id fetches that prefer staying
 * on their record, form pre-fill, etc.).
 */
const useOrgEffect = (effect: EffectCallback, deps: DependencyList) => {
  const { orgVersion } = useOrganizationsStateContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, [...deps, orgVersion]);
};

export default useOrgEffect;
